module.exports = __webpack_public_path__ + "static/media/cb-1.1be8d452.jpg";